const getCurrentLanguageFromPath = (fullPath: string, baseURI: string) => {
    const index = APP_ENV.STORE ? 1 : 2;
    const path = fullPath.substring(baseURI.length - 1, fullPath.length);
    const lang = path.split('/')[index];
    return lang || 'de';
};

export default getCurrentLanguageFromPath;
